import React, { FC } from 'react';

import ReadingsPage from "@/components/readings/ReadingsPage";
import { Medium } from "@/constants/mediums";

const WasteReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.waste} />;
};

export default WasteReadingsPage;
